import React from 'react';

import Modal from '@mui/material/Modal';

import DebitList from './debitAPI';
import ModalHeaderStyle from '../styles/modalHeader';
import ModalBody from '../styles/modalBody';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 'auto',
  height: 'auto',
  boxShadow: 24,
};

export default function ModDabit({
  setStatus,
  status,
  stationId,
  date,
  setDebit,
  stationName,
}) {
  const handleClose = () => {
    setStatus(false);
  };

  return (
    <div className="bg-white">
      <Modal
        open={status}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <div style={style} className={'rounded-lg overflow-hidden '}>
          <div className="w-full flex flex-col bg-white h-full ">
            <ModalHeaderStyle header={'Debit (BTC)'} onClose={handleClose} />

            <div className="flex-grow  bg-white    border-brown">
              <ModalBody>
                <DebitList
                  stationId={stationId}
                  stationName={stationName}
                  setDebit={setDebit}
                  handleClose={handleClose}
                  setStatus={setStatus}
                  date={date}
                />
              </ModalBody>
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
}
